import { BehaviorSubject } from "rxjs";
import { singleton } from "tsyringe";

@singleton()
class NudgesPopUpWidgetVisibilityManager {
    public isNudgesPopUpWidgetOpen$ = new BehaviorSubject<boolean>(false);

    public nudgesPopUpWidgetShow(): void {
        this.isNudgesPopUpWidgetOpen$.next(true);
    }

    public nudgesPopUpWidgetHide(): void {
        this.isNudgesPopUpWidgetOpen$.next(false);
    }
}

export default NudgesPopUpWidgetVisibilityManager;
